import type { Release } from '../releases.ts';

export default {
  version: '0.16.0',
  date: '2026-10-02',
  title: 'Live ingest from watch folders',
  summary: [
    'Live ingest from server watch folders: a growing file appears as recording at once',
    'A live proxy to watch and log about 6 to 10 seconds behind',
    'When the file stops growing, it is ingested into the same asset',
    'The live player joins at the live edge and can scrub back',
  ],
  features: [
    'Live ingest, an option per server watch folder: a file a capture system is still writing (growing MXF, MPEG-TS or fragmented MP4) appears as recording at once, with a live proxy to watch and log about 6 to 10 seconds behind',
    'When the file stops growing, it is ingested into the same asset: original stored, proxies made, workflows triggered; metadata entered while recording is kept',
    'The live player joins at the live edge, shows how far behind live it is, and can scrub back over everything recorded so far',
  ],
  fixes: [],
} satisfies Release;
